<script lang="ts">
    import { Link } from "svelte-navigator";
    import {
        Collapse,
        Navbar,
        NavbarToggler,
        Nav,
        NavItem,
        NavLink,
    } from "sveltestrap";
    import { _ } from "svelte-i18n";
    import { appManager } from "../AppManagerStore";
    import Logo from "../svg/Logo.svelte";

    let isOpen = false;

    function handleUpdate(event) {
        //isOpen = event.detail.isOpen;
    }

    function toggleOpen() {
        isOpen = !isOpen;

        console.log(`${isOpen}`);
    }

    export let background: "dark" | "light" | "none" = "light";
    export let isFluid: boolean = true;
    export let isFixed: boolean = false;
    export let text: "primary" | "white" | "muted" | "" = "";
</script>

<Navbar
    class="navbar navbar-expand-lg 
        {background === "dark"
        ? 'bg-dark navbar-dark'
        : ''} 
        {background === "light"
        ? 'bg-white navbar-light'
        : ''} 
        {background === "none"
        ? 'navbar-dark'
        : ''} 
        {isFixed ? 'fixed-top' : ''}"
    container={!isFluid}>

    <h4 >
        <a
            class="icon footer-brand img-fluid pr-2 text-primary"
            href={$appManager.PublicUrl}>
            <Logo />
        </a> <span class="text-{text}">ANYWAYS</span>
    </h4>

    <NavbarToggler on:click={() => toggleOpen()} />

    <Collapse {isOpen} navbar expand="lg" on:update={handleUpdate}>
        <Nav class="ms-auto" navbar>
            <NavbarToggler on:click={() => toggleOpen()}>
                <i class="fe fe-x" />
            </NavbarToggler>  

            <NavItem>
                <NavLink href="{$appManager.PublicUrl}communicate#pricing"
                    >{$_("menu.pricing")}</NavLink>
            </NavItem>

        </Nav>
            <a
                class="navbar-btn btn btn-sm btn-primary"
                href="{$appManager.PublicUrl}contact">{$_("menu.contact")}</a>
    </Collapse>
</Navbar>

<style>
    .border-container {
        border-top: 1px solid hsla(0,0%,100%,.2);
        bottom: -1.25rem;
        content: "";
        left: 0;
        position: absolute;
        right: 0;
    }

    .add-on {
        position: absolute;
    }
</style>
